export enum KNOWLEDGE_BASE_ENTRY_STATUS {
	PROCESSING = 'processing',
	COMPLETED = 'completed',
	FAILED = 'failed',
}

export enum KNOWLEDGE_BASE_ENTRY_TYPE {
	TEXT = 'text',
	FILE = 'file',
	LINK = 'link',
}
